module.exports = __webpack_public_path__ + "media/images/athletes/1789-2c0a263068f7f9a856116b271c16b166.png";